<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chitimmermans0007#ch01"><b>1:</b>  Surprise</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0008#ch02"><b>2:</b>  Beginnings</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0009#ch03"><b>3:</b>  Theories</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0010#ch04"><b>4:</b>  Collecting</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0011#ch05"><b>5:</b>  Open Coding</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0012#ch06"><b>6:</b>  Focused Coding</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0013#ch07"><b>7:</b>  Clues about Clues</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0014#ch08"><b>8:</b>  Writing It Down, Writing It Up</a></p>
<p class="toc"><a class="xref" href="#/chitimmermans0015#ch09"><b>9:</b>  Abduction in Action</a></p>
<p class="tocbmf"><a class="xref" href="#/chitimmermans0016#app">Appendix: From Qualitative to Computational Abductive Analysis</a></p>
<p class="tocbm"><a class="xref" href="#/chitimmermans0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chitimmermans0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chitimmermans0019#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chitimmermans0020#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-timmermans-0006.vue?1fe1c4e4